
import React, { PropTypes } from 'react';
//import ReactDOM from 'react-dom';

export default class extends React.Component{

	constructor(props){
		super(props);
	}

	render(){
		return (
			<div className="results">
				{
					this.props.results.map((result, i) => {
						var FormattedDate = new Date(result.Date).toLocaleDateString('en-NZ',{year: 'numeric', month: '2-digit', day: '2-digit'});
						return (
							<a href={result.Link} className="result" key={result.ID}>
								<div className="col title">&nbsp;
									{result.Title} 
								</div>
								<div className="col company">{result.OtherCompany}&nbsp;</div>
								<div className="col date">{FormattedDate}&nbsp;</div>
								<div className="col transaction-type">{result.TransactionType}&nbsp;</div>
								<div className="col exemptions">{result.Exemptions}</div>
							</a>
						);
					})
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./app/js/components/TransactionsResults.js